'use strict';

(function (global) {

  // Идентификатор для хранения приватного свойства с jQuery-объектом контрола тулбара
  const toolbarJControlPrivatePropertyKey = Symbol('jControl');

  /**
   * Колнтрол тулбара предпросмотра.
   * Может быть составным - состоять из других контролов.
   *
   * @namespace window.Core.preview.toolbar
   * @since 5.7.0
   */
  class ToolbarControl {

    constructor(selectorList) {
      const selector = '#preview-panel ' + selectorList.join(', #preview-panel ');
      this[toolbarJControlPrivatePropertyKey] = $(selector);
    }

    /**
     * Кнопка тулбара предпросмотра.
     *
     * @private
     * @property _jButton
     * @return {Object} jQuery-объект кнопки тулбара предпросмотра.
     */
    get _jControl() {
      return this[toolbarJControlPrivatePropertyKey];
    }

    /**
     * Спрятать контрол.
     * (Обёртка над jQuery-методом hide)
     *
     * @method hide
     */
    hide() {
      this._jControl.hide();
    }

    /**
     * Показать контрол.
     * (Обёртка над jQuery-методом show)
     *
     * @method show
     */
    show() {
      this._jControl.show();
    }
  }

  global.ToolbarControl = ToolbarControl;

})(window.Core.preview.toolbar);